(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/views/best-row-match.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/views/best-row-match.js'); 'use strict';

svs.sport.best_rows.views.BestRowMatch = Marionette.View.extend({
  template: function template(data) {
    return svs.sport.best_rows.templates.best_row_match(data);
  },
  tagName: 'tr',
  modelEvents: {
    change: 'render',
    statechange: 'render'
  },
  onDomRefresh: function onDomRefresh() {
    this.$el.removeClass('best-rows-match-notstarted best-rows-match-started best-rows-match-ended');
    this.model.on('change', this.updateMatchStarted());
  },

  updateMatchStarted: function updateMatchStarted() {
    if (this.model.get('hasMatchEnded')) {
      this.$el.addClass('best-rows-match-ended');
    } else if (this.model.get('hasMatchStarted')) {
      this.$el.addClass('best-rows-match-started');
    } else {
      this.$el.addClass('best-rows-match-notstarted');
    }
  }
});
 })(window);